<div class="loader" [ngClass]="{
    'loader--absolute': !fixed,
    'loader--fixed': fixed
}">
    <div class="loader__progress"></div>
</div>
